module.exports = __webpack_public_path__ + "static/media/icon-bg-lblue.2db05298.svg";